var _style, _path, _defs, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiffFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#E8ECEF;}\n\t.st1{clip-path:url(#SVGID_00000075141329851592851290000001540485116193350272_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#7B0000;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#BF3939;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,0.5h262c6.9,0,12.5,5.6,12.5,12.5v262c0,6.9-5.6,12.5-12.5,12.5H13c-6.9,0-12.5-5.6-12.5-12.5V13 C0.5,6.1,6.1,0.5,13,0.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 110.3,
    y: 100,
    width: 67.4,
    height: 88
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099653496332910726640000016105077047270734751_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000099653496332910726640000016105077047270734751_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.7,123.2v57.9c0,3.8-3.1,7-7,7h-53.5c-3.9,0-7-3.1-7-7v-74.1c0-3.8,3.1-7,7-7h37.2L177.7,123.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M159.8,146.8c-0.6-0.2-1.2-0.3-1.7-0.3c-0.6,0-1.1,0.1-1.3,0.4c-0.2,0.3-0.4,0.7-0.4,1.4v1.3h2.7v2.6h-2.7 v10.5h-3.2v-10.5h-1.7v-2.6h1.7v-1.3c0-1.6,0.4-2.8,1.2-3.5c0.8-0.7,2-1.1,3.6-1.1c0.8,0,1.6,0.1,2.4,0.3L159.8,146.8z  M149.9,146.5c-0.6,0-1.1,0.1-1.3,0.4c-0.2,0.3-0.4,0.7-0.4,1.4v1.3h2.7v2.6h-2.7v10.5H145v-10.5h-1.7v-2.6h1.7v-1.3 c0-1.6,0.4-2.8,1.2-3.5c0.8-0.7,2-1.1,3.6-1.1c0.8,0,1.6,0.1,2.4,0.3l-0.6,2.8C151,146.6,150.4,146.5,149.9,146.5z M140,147.6 c-0.7,0-1.1-0.1-1.4-0.4c-0.2-0.3-0.4-0.7-0.4-1.2c0-0.6,0.1-1,0.4-1.3c0.3-0.3,0.7-0.4,1.4-0.4c0.6,0,1.1,0.1,1.4,0.4 c0.3,0.2,0.4,0.7,0.4,1.3c0,0.6-0.1,1-0.4,1.3C141,147.5,140.6,147.6,140,147.6z M130.9,162c-0.7-0.7-1-1.8-1-3.3v-6.6h-1.7v-2.6 h1.7v-3.6h3.2v3.6h3v2.6h-3v6.1c0,0.8,0.1,1.4,0.4,1.7c0.3,0.3,0.6,0.4,1.1,0.4c0.6,0,1.2-0.1,1.8-0.4l0.6,2.6 c-0.9,0.3-1.8,0.4-2.7,0.4C132.7,163,131.6,162.7,130.9,162z M141.6,162.6h-3.2v-13.1h3.2V162.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.7,121.9v2.9h-19c-3.9,0-5.7-3.2-5.7-7.1V100h2.9L177.7,121.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiffFile);
export default __webpack_public_path__ + "static/media/tiff-file.7e1cbb46ac46892b862ef9049084c023.svg";
export { ForwardRef as ReactComponent };